'use client';

import CommercetoolsCheckout from 'components/gruenland/organisms/checkout/ct-checkout';

const YggdrasilCheckoutTastic = () => {
  //CT-Checkout
  return <CommercetoolsCheckout />;
};

export default YggdrasilCheckoutTastic;
